import { MovieClip, FrameScriptManager } from '@awayjs/scene';
import { IS_AX_CLASS } from './AXClass';
var ActiveLoaderContext = /** @class */ (function () {
    function ActiveLoaderContext() {
    }
    return ActiveLoaderContext;
}());
export { ActiveLoaderContext };
// todo: move OrphanManager elsewhere and add strong type
// maybe eve solve the orphan-issue in otherway alltogether
var OrphanManager = /** @class */ (function () {
    function OrphanManager() {
    }
    OrphanManager.addOrphan = function (orphan) {
        if (OrphanManager.orphans.indexOf(orphan) !== -1)
            return;
        OrphanManager.orphans.push(orphan);
    };
    OrphanManager.removeOrphan = function (orphan) {
        var index = OrphanManager.orphans.indexOf(orphan);
        if (index === -1)
            return;
        OrphanManager.orphans.splice(index, 1);
    };
    OrphanManager.updateOrphans = function () {
        var orphan;
        for (var i = 0; i < OrphanManager.orphans.length; i++) {
            orphan = OrphanManager.orphans[i];
            if (orphan.isAsset(MovieClip)) {
                orphan.advanceFrame();
                FrameScriptManager.execute_as3_constructors_recursiv(orphan);
            }
        }
    };
    OrphanManager.orphans = [];
    return OrphanManager;
}());
export { OrphanManager };
var initTraitsForObject = function (object, traits) {
    if (!traits)
        return;
    if (traits.slots) {
        for (var i = 0; i < traits.slots.length; i++) {
            if (traits.slots[i]) {
                object[traits.slots[i].name.getMangledName()] = traits.slots[i].value;
            }
        }
    }
    if (traits.superTraits)
        initTraitsForObject(object, traits.superTraits);
    return object;
};
/**
 * Generic axConstruct method that lives on the AXClass prototype. This just
 * creates an empty object with the right prototype and then calls the
 * instance initializer.
 *
 * TODO: Flatten out the argArray, or create an alternate ax helper to
 * make object construction faster.
 */
export function axConstruct(argArray) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _this = this;
    var object = Object.create(_this.tPrototype);
    initTraitsForObject(object, _this.tPrototype.traits);
    var symbol = null;
    var timeline = null;
    var classToCheck = _this;
    //  find the AwayJS-timline that should be used for this MC. might be on superclass...
    while (classToCheck && !timeline) {
        symbol = classToCheck._symbol;
        if (symbol && symbol.timeline)
            timeline = symbol.timeline;
        classToCheck = classToCheck.superClass;
    }
    if (timeline) {
        var newMC = new MovieClip(timeline);
        object.adaptee = newMC;
        var foundUIComponent = false;
        if (this._symbol) {
            var symbolClass = this._symbol.symbolClass;
            while (symbolClass && !foundUIComponent) {
                if (((_a = symbolClass.name) === null || _a === void 0 ? void 0 : _a.name) == 'UIComponent') {
                    foundUIComponent = true;
                }
                else if (((_b = symbolClass.name) === null || _b === void 0 ? void 0 : _b.name) == 'MovieClip') {
                    symbolClass = null;
                }
                else if (((_c = symbolClass.name) === null || _c === void 0 ? void 0 : _c.name) == 'Sprite') {
                    foundUIComponent = true;
                }
                else if (symbolClass.superClass) {
                    symbolClass = symbolClass.superClass;
                }
                else {
                    symbolClass = null;
                }
            }
            // 	hack to BadIceCreamFont compiledClip:
            //	the compiledClip "BadIcecreamFont" seem to behave different to other classes
            //	it seem to always stick to frame 0,
            //
            //	DANGER!!!
            //	MAY PRODUCE SIDE EFFECTS
            var cn = this._symbol.className;
            var freezeOnFirstFrame = foundUIComponent || (cn && (
            //anyThis._symbol.className == "BadIcecreamFont" ||
            cn.includes('Font')));
            if (freezeOnFirstFrame) {
                var timeline_1 = newMC.timeline;
                var targetTimeline = timeline_1;
                targetTimeline.frame_command_indices = [timeline_1.frame_command_indices[0]];
                targetTimeline.frame_recipe = [timeline_1.frame_recipe[0]];
                targetTimeline.keyframe_constructframes = [timeline_1.keyframe_constructframes[0]];
                targetTimeline.keyframe_durations = [timeline_1.keyframe_durations[0]];
                targetTimeline.keyframe_firstframes = [timeline_1.keyframe_firstframes[0]];
                targetTimeline.keyframe_indices = [timeline_1.keyframe_indices[0]];
            }
        }
        newMC.reset();
        FrameScriptManager.execute_as3_constructors_recursiv(newMC);
    }
    //	ActiveLoaderContext.loaderContext is a hack !
    //	in future the appDom should be provided by the symbol
    //	UNSAFE! Need check more clea because assets can has nested class defenetion,
    //  like as `BitmapAsset : FlexBitmap: Bitmap`
    var name = (_g = (_f = (_e = (_d = _this.superClass) === null || _d === void 0 ? void 0 : _d.classInfo) === null || _e === void 0 ? void 0 : _e.instanceInfo) === null || _f === void 0 ? void 0 : _f.name) === null || _g === void 0 ? void 0 : _g.name;
    var appDom;
    if (_this.axApplicationDomain && _this.axApplicationDomain.awayApplicationDomain) {
        appDom = _this.axApplicationDomain.awayApplicationDomain;
    }
    else if (ActiveLoaderContext.loaderContext) {
        appDom = ActiveLoaderContext.loaderContext.applicationDomain;
    }
    //	const lookup: IAssetLookup = name ? ASSET_LOOKUP[name] : null;
    var mn = _this.classInfo.instanceInfo.name;
    var instName = mn.name;
    var fullName = mn.uri ? mn.uri + '.' + instName : instName;
    if (!timeline && appDom && appDom.hasSymbolForClass(fullName)) {
        var asset = appDom.getSymbolAdaptee(fullName);
        if (!asset) {
            // eslint-disable-next-line max-len
            console.warn("error: could not get asset " + name + " for class " + instName + ", no ActiveLoaderContext.loaderContext");
        }
        if (asset) {
            if (asset instanceof MovieClip) {
                object.adaptee.graphics = asset.graphics;
            }
            else {
                object.adaptee = asset;
            }
        }
    }
    // @todo: this is a hack for getting adaptee
    // for dynamic created SimpleButton
    if (((_k = (_j = (_h = this.classInfo) === null || _h === void 0 ? void 0 : _h.instanceInfo) === null || _j === void 0 ? void 0 : _j.name) === null || _k === void 0 ? void 0 : _k.name) == 'SimpleButton') {
        object.adaptee = new MovieClip();
    }
    // mark object that it is AX object, not a regular class
    object[IS_AX_CLASS] = true;
    // eslint-disable-next-line prefer-spread
    object.axInitializer.apply(object, argArray);
    object.constructorHasRun = true;
    if (object.adaptee instanceof MovieClip)
        OrphanManager.addOrphan(object.adaptee);
    if (object.isAVMFont) {
        // hack for font: make sure the fontName is set on Font
        object.fontName = instName;
    }
    return object;
}
